import FormItemFactory from './FormItemFactory';
import controls from '../controls/index';
const instance = new FormItemFactory();
controls.forEach(control => instance.register(control));
export default instance;